import ApplicationController from './application_controller';

export default class extends ApplicationController {
  clearAll() {
    const isDesktop = window.innerWidth >= 1024;

    if (!isDesktop) {
      this.clearDates();
      this.clearGuests();
    }

    this.clearPriceRange();
    this.clearRoomCount();
    this.clearCheckboxes();
    this.clearShowMoreControllers();
  }

  clearDates() {
    const checkIn = document.getElementById('check-in');
    const checkOut = document.getElementById('check-out');
    const hiddenArrivalDate = document.getElementById('hidden-arrival-date');
    const hiddenDepartureDate = document.getElementById('hidden-departure-date');
    const desktopDateDisplay = document.getElementById('desktop-arrival-departure');

    if (checkIn && checkOut) {
      checkIn.textContent = 'Check In';
      checkOut.textContent = 'Check Out';
    }

    if (hiddenArrivalDate) hiddenArrivalDate.value = '';
    if (hiddenDepartureDate) hiddenDepartureDate.value = '';

    if (desktopDateDisplay) {
      desktopDateDisplay.textContent = 'Check In — Out';
    }

    const datepickerElements = document.querySelectorAll('[data-controller*="datepicker"]');
    datepickerElements.forEach((element) => {
      const controller = window.Stimulus.getControllerForElementAndIdentifier(element, 'datepicker');
      if (controller && controller.flatpickrInstance) {
        controller.flatpickrInstance.clear();
      }
    });
  }

  clearGuests() {
    const guestCountSpans = document.querySelectorAll('.guest-count');
    const countSpans = document.querySelectorAll('.total-guest-count');

    if (guestCountSpans) {
      guestCountSpans.forEach((span) => {
        span.textContent = '0';
      });
    }

    if (countSpans) {
      countSpans.forEach((span) => {
        span.textContent = 'Guests';
      });
    }

    const hiddenAdults = document.getElementById('hidden-adults');
    const hiddenChildren = document.getElementById('hidden-children');
    const hiddenPets = document.getElementById('hidden-pets');

    if (hiddenAdults) hiddenAdults.value = '0';
    if (hiddenChildren) hiddenChildren.value = '0';
    if (hiddenPets) hiddenPets.value = '0';

    const guestsElements = document.querySelectorAll('[data-controller*="guests"]');
    guestsElements.forEach((element) => {
      const controller = window.Stimulus.getControllerForElementAndIdentifier(element, 'guests');
      if (controller && controller.updateGuestsCount) {
        controller.updateGuestsCount();
      }
    });
  }

  clearPriceRange() {
    const priceSliders = document.querySelectorAll('[data-controller*="price-slider"] [data-price-slider-target="slider"]');
    const minPriceInputs = document.querySelectorAll('[data-price-slider-target="minPrice"]');
    const maxPriceInputs = document.querySelectorAll('[data-price-slider-target="maxPrice"]');

    priceSliders.forEach((slider) => {
      if (slider && slider.noUiSlider) {
        try {
          slider.noUiSlider.set([0, 500]);
        } catch (error) {
          // Ignore errors
        }
      }
    });

    minPriceInputs.forEach((input) => {
      if (input) {
        input.value = '0';
        if (!input.hasAttribute('name')) {
          input.setAttribute('name', 'min_price');
        }
      }
    });

    maxPriceInputs.forEach((input) => {
      if (input) {
        input.value = '500';
        if (!input.hasAttribute('name')) {
          input.setAttribute('name', 'max_price');
        }
      }
    });

    const priceSlider = document.getElementById('slider');
    const minPriceInput = document.getElementById('min-price');
    const maxPriceInput = document.getElementById('max-price');

    if (priceSlider && priceSlider.noUiSlider) {
      try {
        priceSlider.noUiSlider.set([0, 500]);
      } catch (error) {
        // Ignore errors
      }
    }

    if (minPriceInput) {
      minPriceInput.value = '0';
      if (!minPriceInput.hasAttribute('name')) {
        minPriceInput.setAttribute('name', 'min_price');
      }
    }
    if (maxPriceInput) {
      maxPriceInput.value = '500';
      if (!maxPriceInput.hasAttribute('name')) {
        maxPriceInput.setAttribute('name', 'max_price');
      }
    }
  }

  clearRoomCount() {
    const roomCountSpans = document.querySelectorAll("[data-room-count-target='roomCount']");
    const hiddenRoomsInputs = document.querySelectorAll("[data-room-count-target='hiddenRooms']");

    roomCountSpans.forEach((span) => {
      if (span) {
        span.textContent = '1';
      }
    });

    hiddenRoomsInputs.forEach((input) => {
      if (input) {
        input.value = '1';
      }
    });

    const roomCountElements = document.querySelectorAll('[data-controller*="room-count"]');
    roomCountElements.forEach((element) => {
      const controller = window.Stimulus.getControllerForElementAndIdentifier(element, 'room-count');
      if (controller) {
        if (controller.roomCountTarget) controller.roomCountTarget.textContent = '1';
        if (controller.hiddenRoomsTarget) controller.hiddenRoomsTarget.value = '1';
      }
    });
  }

  clearCheckboxes() {
    const checkboxes = document.querySelectorAll("input[type='checkbox']");
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  clearShowMoreControllers() {
    const showMoreControllers = document.querySelectorAll("[data-controller*='show-more']");

    showMoreControllers.forEach((element) => {
      const showMoreController = window.Stimulus.getControllerForElementAndIdentifier(
        element,
        'show-more',
      );
      if (showMoreController && showMoreController.checkedFilters) {
        showMoreController.checkedFilters.clear();
        if (showMoreController.renderFilters) {
          showMoreController.renderFilters();
        }
      }
    });

    const amenityCheckboxes = document.querySelectorAll('input[name="amenity"]');
    const propertyTypeCheckboxes = document.querySelectorAll('input[name="property_type"]');

    amenityCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    propertyTypeCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
